import { getProvider } from "../providerInstance";
import { getState, updateState } from "../state";

export async function refreshAuditLog(): Promise<void> {
  try {
    const entries = await getProvider().listAuditLog();
    updateState({ auditLog: entries });
  } catch {
    // Audit log is best-effort — don't break the app if sheet is missing
  }
}

export async function logAction(
  action: string,
  targetType: string,
  targetId: string,
  details: string,
): Promise<void> {
  try {
    await getProvider().appendAuditEntry({
      action,
      targetType,
      targetId,
      details,
      user: "current-user",
      timestamp: new Date().toISOString(),
    });
  } catch {
    // Best-effort logging
  }
}
